import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import DataMarketingCv from "./DataMarketingCv";
import Laika from "./Laika";
import Linkedin from "./Linkedin";
import FooterHome from "./FooterHome";

const DataMarketing = (props) => {
  const [editMode, setEditMode] = useState(false);
  const [hovering, update] = useState(false);
  const [tip, setTip] = useState(false);
  const [showImage, setShowImage] = useState(false);

  let subpage;
  const handleHover = (isHovering, tip) => {
    console.log(isHovering, tip);
    update(isHovering);
    setTip(tip);
  };

  const handleShow = (show) => {
    setShowImage(show);
  };

  switch (props.match.params.subpage) {
    case "linkedin":
      subpage = <Linkedin disableButton={true} handleHover={handleHover} />;
      break;
    case "laika":
      subpage = <Laika disableButton={true} handleHover={handleHover} />;
      break;
    case undefined:
      subpage = (
        <DataMarketingCv
          disableButton={true}
          editMode={editMode}
          handleShow={handleShow}
          handleHover={handleHover}
        />
      );
      break;
    default:
      console.log(props.match.params.subpage);
      break;
  }

  const popUp = () => {
    return (
      <div id="popUp">
        <img src="/images/home.png" alt="img" />
      </div>
    );
  };

  return (
    <>
      {showImage ? (
        popUp()
      ) : (
        <div className="container-fluid">
          <div
            className="DataMarketing"
            style={{ backgroundImage: "url(/images/background.png)" }}
          >
            <div className="row">
              <div className="col p-4">
                <h2>Digital Marketing</h2>
              </div>
            </div>
            <div className="row mx-0">
              <div className="col-md-9  mb-5 border bg-white shadow">
                <div className="row">
                  <div className="col-md-10 offset-md-1">
                    <div className="row p-4">
                      <div className="col-md-3">
                        <NavLink
                          activeClassName="chosen"
                          exact
                          className="btn form-control buttonHome"
                          to="/datamarketing"
                        >
                          CV
                        </NavLink>
                      </div>
                      <div className="col-md-3">
                        <NavLink
                          activeClassName="chosen"
                          className="btn form-control buttonHome"
                          to="/datamarketing/linkedin"
                        >
                          LINKEDIN
                        </NavLink>
                      </div>
                      <div className="col-md-3">
                        <NavLink
                          activeClassName="chosen"
                          className="btn form-control buttonHome"
                          to="/datamarketing/laika"
                        >
                          WEARELAIKA.COM
                        </NavLink>
                      </div>
                      {props.match.params.subpage === "linkedin" ||
                      props.match.params.subpage === "laika" ? (
                        ""
                      ) : (
                        <div className="col-md-2 offset-md-1">
                          <a
                            onClick={() => {
                              setEditMode(!editMode);
                            }}
                            className=" form-control buttonHome"
                          >
                            {editMode ? "VIEW" : "EDIT"}
                          </a>
                        </div>
                      )}
                    </div>
                    <div>{subpage}</div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className=" w-100 border shadow bg-white textarr">
                  <div className="p-3 mainPara">
                    {hovering && <div>{tip}</div>}
                  </div>
                </div>
              </div>
            </div>
            <FooterHome />
          </div>
        </div>
      )}
    </>
  );
};

export default DataMarketing;
